import PropType from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import Context from '../../context'
import { ParserPartner } from '../../helpers/ParserHelper'
import { getPartnerById } from '../../services/ClubeApi'
import history from '../../services/history'
import SelectFilterStatus from '../SelectFilterStatus'
import SelectUserGroupFilter from '../SelectUserGroupFilter'
import SearchField from './SearchField'

function TopSearch({
  buttonLabel,
  goTo,
  showEditPartner,
  showFilter,
  showUserFilter,
  searchAction,
  filterAction,
  showAddPushButton,
  showAddUserButton,
  setEditPushNotificationData
}) {
  const { setEditUnity, setEditPartner } = useContext(Context)
  const { editPartner, setPartnerToEdit } = useContext(Context)
  const [searchStr, setSearchStr] = useState('')

  useEffect(() => {
    searchAction(searchStr)
  }, [searchStr])

  const handleCreate = () => {
    if (setEditUnity) {
      setEditUnity(null)
      if (goTo === '/partnerform') {
        setEditPartner({ id: null })
      }
    }
    history.push(goTo)
  }

  const handleEditPartner = () => {
    if (editPartner.id !== null) {
      const getPartnerToEdit = async () => {
        return getPartnerById(editPartner.id)
      }
      getPartnerToEdit().then(r => {
        setPartnerToEdit(ParserPartner(r))
      })
    } else {
      setPartnerToEdit({})
    }
    history.push('/partnerform')
  }

  const clearInput = value => {
    if (value.length < 3) {
      setSearchStr('')
    }
  }

  return (
    <div className="component-top">
      <div className="d-flex flex-row ">
        <div className="flex-grow-1">
          <SearchField />
        </div>

        {showFilter && <SelectFilterStatus filterAction={filterAction} />}
        {showUserFilter && <SelectUserGroupFilter filterAction={filterAction} />}

        {showEditPartner && (
          <button onClick={handleEditPartner} type="button" className="btn clube-btn clube-blue">
            Editar Parceiro
          </button>
        )}
        {buttonLabel && (
          <button onClick={handleCreate} type="button" className="btn clube-btn clube-blue">
            {buttonLabel}
          </button>
        )}
        {showAddPushButton && (
          <button
            type="button"
            className="btn clube-btn clube-blue"
            data-toggle="modal"
            data-target="#addNotification"
            onPress={() => setEditPushNotificationData(null)}
          >
            Adicionar Notificação
          </button>
        )}

        {showAddUserButton && (
          <button
            type="button"
            className="btn clube-btn clube-blue"
            data-toggle="modal"
            data-target="#userCreateModal"
          >
            Adicionar Usuário
          </button>
        )}
      </div>
    </div>
  )
}

TopSearch.defaultProps = {
  buttonLabel: null,
  goTo: null,
  showEditPartner: false,
  showFilter: false,
  showUserFilter: false,
  showAddPushButton: false,
  showAddUserButton: false,
  searchAction: () => {},
  filterAction: () => {}
}

TopSearch.propTypes = {
  buttonLabel: PropType.string,
  goTo: PropType.string,
  showEditPartner: PropType.bool,
  showUserFilter: PropType.bool,
  showAddPushButton: PropType.bool,
  showAddUserButton: PropType.bool,
  showFilter: PropType.bool,
  searchAction: PropType.func,
  filterAction: PropType.func
}

export default TopSearch
